<script>
export default {
  props: {
    snackbar: { type: Boolean, required: true },
    snackbarMessage: { type: String, required: true },
  },
}
</script>

<template>
  <v-snackbar
    v-model="snackbar"
    content-class="body--text"
    height="65"
    color="#71b83b"
    :timeout="3000"
    top
  >
    <div class="d-flex">
      <v-icon color="#fff" class="my-auto">mdi-check-circle</v-icon>
      <div class="my-auto ml-3" style="color: white">
        {{ snackbarMessage }}
      </div>
    </div>

    <template v-slot:action="{ attrs }">
      <v-btn icon color="#fff" text v-bind="attrs" @click="snackbar = false">
        <v-icon color="#fff">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style lang="scss" module>
@import '@design';
</style>
